// Copyright (c) 2016 Deere & Company

import './emissions-part-search-report.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import EmissionsPartSearch from '@deere/cps-it.warranty-model-factory/lib/emissions-part-search';
import EmissionsPartSearchCriteria from './emissions-part-search-criteria';
import FavoriteIcon from '../../../shared/components/favorites/favorite-icon';
import {FormattedMessage} from 'react-intl';
import NumberOfRecordsFound from '../../../shared/components/number-of-records-found';
import ReportGrid from '../../shared/components/report-grid';
import ReportHeader from '../../shared/components/report-header';
import ReportHiddenColumns from '../../shared/components/report-columns';
import ReportLayout from '@deere/cps-it.warranty-model-factory/lib/report-layout';
import ShowNoResultsFound from '../../shared/components/show-no-results-found/show-no-results-found';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {getAgGridLocaleText} from '../../../shared/utils/ag-grid-locale-text';
import {getDefaultReportLayout} from '../../shared/services/report-variant';
import {getEmissionsPartSearchColumnDefinitions} from '../report-services/column-definitions';

function updatePartSearchCriteria(event) {

    const partNumber = event.target.value;

    this.actions.updateEmissionsPartSearchCriteria(partNumber);

}

function fetchEmissionsPartSearchValidity() {

    this.actions.fetchEmissionsQualification({partNumber: this.partNumberSearchCriteria});

}

function resetPartSearchCriteria() {

    this.actions.resetEmissionsPartSearch();
    this.actions.updateShowNoResultsFound(false);

}

function handleGridApiDefinition(params) {

    let defaultColumnState,
        defaultSortModel;

    this.actions.createAgGridApi(params.api, params.columnApi);

    if (this.selectedLayout && this.selectedLayout.name && !this.isInitialLoad) {

        const defaultLayout = this.layouts.find(layout => !layout.name);

        defaultColumnState = defaultLayout.columnState;
        defaultSortModel = defaultLayout.sortModel;

    } else {

        defaultColumnState = params.columnApi.getColumnState();
        defaultSortModel = params.api.getSortModel();

        this.actions.updateReportProperty('isInitialLoad', false);

    }

    this.actions.updateDefaultLayout(defaultColumnState, defaultSortModel);

    if (this.selectedLayout && this.selectedLayout.name) {

        params.columnApi.setColumnState(this.selectedLayout.columnState);
        params.api.setSortModel(this.selectedLayout.sortModel);
        params.api.setFilterModel(this.selectedLayout.filterModel);

    } else {

        const defaultLayout = getDefaultReportLayout(defaultColumnState, defaultSortModel);

        this.actions.updateReportProperty('selectedLayout', defaultLayout);

    }

}

function onColumnRemoved(columnEvent) {

    if (!columnEvent.visible) {

        this.actions.hideReportColumn(this.columnApi.getColumnState());

    }

}

class EmissionsPartSearchReport extends Component {

    componentWillMount() {

        this.props.actions.getReportLayouts('emissions-part-search');

    }

    componentDidUpdate(prevProps) {

        if (!prevProps.report.length && !prevProps.showNoResultsFound) {

            if (this.props.selectedLayout && Object.keys(this.props.columnApi).length && this.props.isDefaultColumnStateAvailable) {

                this.props.columnApi.setColumnState(this.props.selectedLayout.columnState);
                this.props.gridApi.setSortModel(this.props.selectedLayout.sortModel);
                this.props.gridApi.setFilterModel(this.props.selectedLayout.filterModel);

            }

        }

    }

    componentWillUnmount() {

        this.props.actions.resetEmissionsPartSearch();
        this.props.actions.updateShowNoResultsFound(false);
        this.props.actions.resetReportVariant();

    }

    render() {

        return (
            <section className='emissions-part-search'>
                <h2 className='emissions-part-search-title'>
                    <FormattedMessage id='EMISSIONS_PART_SEARCH'/>
                    <FavoriteIcon
                        id='EMISSIONS_PART_SEARCH'
                        route={this.props.pathName}
                    />
                </h2>
                <EmissionsPartSearchCriteria
                    onCriteriaReset={this.props::resetPartSearchCriteria}
                    onPartNumberSearch={this.props::updatePartSearchCriteria}
                    onPartSearchExecute={this.props::fetchEmissionsPartSearchValidity}
                    partNumber={this.props.partNumberSearchCriteria}
                />
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                {this.props.report.length ?
                    <div>
                        <NumberOfRecordsFound count={this.props.report.length}/>
                        <section className='report'>
                            {this.props.isReportColumnsVisible && <ReportHiddenColumns/>}
                            <ReportHeader
                                columnApi={this.props.columnApi}
                                gridApi={this.props.gridApi}
                                reportName='emissions-part-search'
                            />
                            <ReportGrid
                                columnDefs={getEmissionsPartSearchColumnDefinitions()}
                                localeText={getAgGridLocaleText()}
                                onColumnVisible={this.props::onColumnRemoved}
                                onGridReady={this.props::handleGridApiDefinition}
                                rowData={this.props.report}
                            />
                        </section>
                    </div> :
                    <ShowNoResultsFound showNoResultsFound={this.props.showNoResultsFound}/>
                }
            </section>
        );

    }

}

EmissionsPartSearchReport.displayName = 'EmissionsPartSearchReport';
EmissionsPartSearchReport.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    columnApi: PropTypes.object.isRequired,
    gridApi: PropTypes.object.isRequired,
    isDefaultColumnStateAvailable: PropTypes.bool.isRequired,
    isInitialLoad: PropTypes.bool.isRequired,
    isReportColumnsVisible: PropTypes.bool.isRequired,
    layouts: PropTypes.arrayOf(PropTypes.instanceOf(ReportLayout)).isRequired,
    partNumberSearchCriteria: PropTypes.string.isRequired,
    pathName: PropTypes.string.isRequired,
    report: PropTypes.arrayOf(PropTypes.instanceOf(EmissionsPartSearch)),
    selectedLayout: PropTypes.instanceOf(ReportLayout),
    showNoResultsFound: PropTypes.bool.isRequired
};

export default EmissionsPartSearchReport;



// WEBPACK FOOTER //
// ./src/reports/emissions-part-search/components/emissions-part-search-report.js